<template>
  <div class="flowbuilder-node-container" ref="containerEl">
    <BaseNode
      :node="node"
      :icon="nodeIcon"
      :metrics="metrics"
      :mini-metrics="true"
      @click="emit('click')"
      @delete-node="emit('delete-node')"
      classes="bg-sky-100 ring-sky-400/50 dark:bg-sky-950 dark:ring-sky-500/50">
      <template #context>Fire webhook:</template>

      <div v-if="node.name" class="mt-3">{{ node.name }}</div>

      <div v-if="node.url" class="mt-1">
        <div class="text-sm font-mono">
          {{ node.method || 'POST' }} → {{ truncatedUrl }}
        </div>
        <div
          v-if="node.fireOnce !== false"
          class="mt-2 inline-flex items-center gap-x-1 rounded bg-sky-500/10 px-1.5 py-0.5">
          <div class="text-xs">Once per visitor</div>
        </div>
      </div>
      <template v-else>Configure webhook URL</template>
    </BaseNode>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, inject } from 'vue'
import BaseNode from './BaseNode.vue'
import { getNodeIcon } from '../../utils/nodeIcons'
import type { NodeWebhook } from '../../types/nodes'

interface Props {
  node: NodeWebhook
}

const props = defineProps<Props>()
const emit = defineEmits(['delete-node', 'click'])

const containerEl = ref<HTMLElement>()

const getNodeMetrics = inject<(node: any) => any>('getNodeMetrics', () => null)

const nodeIcon = computed(() => getNodeIcon(props.node))

const metrics = computed(() => getNodeMetrics(props.node))

const truncatedUrl = computed(() => {
  const url = props.node.url
  return url.length > 40 ? url.slice(0, 40) + '...' : url
})
</script>
